import React, {useEffect, useState} from 'react'
import CoinMarket from './CoinMarket';
import WalletCards from '../Wallet/WalletCards';

import Cards from '../Cards/Cards';
import MobileMenu from './MobileMenu';
import NewCard from '../Cards/NewCard';
import { Divider } from '@mui/material';
import BalanceCard from '../Cards/BalanceCard';

import { Card, CardContent, Typography, Grid, Box, Avatar, LinearProgress, Chip, Button } from '@mui/material';
import { useSelector } from 'react-redux';
import VerifiedIcon from '@mui/icons-material/Verified';
import NewReleasesIcon from '@mui/icons-material/NewReleases';
import SearchButton from '../Search/SearchButton';
import BlogSlider from '../Blog/BlogSlider';
import MarketTabs from '../Markets/MarketTabs';
import InvestmentSlide from '../BybitTrade/CoinSlide';

import ListStock from '../Stock/ListStock'
import StockSlide from '../Stock/StockSlide';

// Financial Dashboard Icons
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import GroupIcon from '@mui/icons-material/Group';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import SavingsIcon from '@mui/icons-material/Savings';
import PaidIcon from '@mui/icons-material/Paid';
import { Link as RouterLink } from 'react-router-dom';

const Index = () => {

  const appMode = useSelector((state) => state.mode.mode);
  const user = useSelector((state) => state.user.user);
  const fundingBal = useSelector((state) => state.wallet.fundingBalance);
  const subBal = useSelector((state) => state.wallet.subscriptionBalance);
  const refBal = useSelector((state) => state.wallet.referralBalance);
  const mainBal = useSelector((state) => state.wallet.withdrawableBalance);
  
  // Get actual data from Redux store
  const plans = useSelector((state) => state.plans.plans);
  const traders = useSelector((state) => state.traders.traders);
  
  const [ip, setIP] = useState("192.168.23.5");
  
  const formatPrice = (amount)=> new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', currencySign: 'standard' }).format(amount);

  const getData = async () => {
    fetch('https://api.ipify.org?format=json')
    .then(response => response.json())
    .then(data => setIP(data.ip))
    .catch(error => console.log(error))
  };

  useEffect(() => {
    getData();
  }, []);

  // Transform traders data to investment opportunities format
  const investmentOpportunities = traders.slice(0, 3).map(trader => ({
    id: trader.id,
    title: trader.trader_name,
    description: trader.description || `Professional ${trader.level} trader with proven track record`,
    targetAmount: parseFloat(trader.min_amount) * 10, // Estimate target amount
    raisedAmount: parseFloat(trader.min_amount) * 5, // Estimate raised amount
    expectedReturn: `${trader.gain}%`,
    duration: trader.duration,
    riskLevel: trader.risk_score <= 3 ? 'Low' : trader.risk_score <= 5 ? 'Medium' : 'High',
    category: trader.category || 'Trading',
    trader: trader
  }));

  const getRiskColor = (risk) => {
    switch(risk) {
      case 'Low': return '#4caf50';
      case 'Medium': return '#ff9800';
      case 'High': return '#f44336';
      default: return '#9e9e9e';
    }
  };

  return (
    <>
    <div style={{height: '65px'}}></div>
    

    {/* Enhanced Balance Card */}
    <BalanceCard/>

    {/* Mobile Menu */}
    <MobileMenu/>

    {/* Account Balances */}
    <Card sx={{ mb: 3, mx: 1 }}>
      <CardContent sx={{ py: 2 }}>
        <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
          <AccountBalanceWalletIcon color="primary" />
          Account Balances
        </Typography>
        
        <Grid container spacing={1.5}>
          <Grid item xs={6} sm={3}>
            <Box sx={{ 
              p: 1.5, 
              borderRadius: 2, 
              background: appMode === 'dark' 
                ? 'rgba(255,255,255,0.02)' 
                : 'rgba(0,0,0,0.01)',
              border: appMode === 'dark'
                ? '1px solid rgba(255,255,255,0.08)'
                : '1px solid rgba(0,0,0,0.06)',
              textAlign: 'center'
            }}>
              <AccountBalanceWalletIcon sx={{ 
                color: appMode === 'dark' ? 'rgba(255,255,255,0.7)' : 'rgba(0,0,0,0.6)', 
                mb: 0.5,
                fontSize: '1.2rem'
              }} />
              <Typography variant="body2" sx={{ 
                fontWeight: 600, 
                color: appMode === 'dark' ? '#fff' : '#1a1a1a',
                mb: 0.2
              }}>
                {formatPrice(fundingBal || 0)}
              </Typography>
              <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.7rem' }}>
                Overall Assets
              </Typography>
            </Box>
          </Grid>

          <Grid item xs={6} sm={3}>
            <Box sx={{ 
              p: 1.5, 
              borderRadius: 2, 
              background: appMode === 'dark' 
                ? 'rgba(255,255,255,0.02)' 
                : 'rgba(0,0,0,0.01)',
              border: appMode === 'dark'
                ? '1px solid rgba(255,255,255,0.08)'
                : '1px solid rgba(0,0,0,0.06)',
              textAlign: 'center'
            }}>
              <TrendingUpIcon sx={{ 
                color: appMode === 'dark' ? 'rgba(255,255,255,0.7)' : 'rgba(0,0,0,0.6)', 
                mb: 0.5,
                fontSize: '1.2rem'
              }} />
              <Typography variant="body2" sx={{ 
                fontWeight: 600, 
                color: appMode === 'dark' ? '#fff' : '#1a1a1a',
                mb: 0.2
              }}>
                {formatPrice(subBal || 0)}
              </Typography>
              <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.7rem' }}>
                Invested Capital
              </Typography>
            </Box>
          </Grid>

          <Grid item xs={6} sm={3}>
            <Box sx={{ 
              p: 1.5, 
              borderRadius: 2, 
              background: appMode === 'dark' 
                ? 'rgba(255,255,255,0.02)' 
                : 'rgba(0,0,0,0.01)',
              border: appMode === 'dark'
                ? '1px solid rgba(255,255,255,0.08)'
                : '1px solid rgba(0,0,0,0.06)',
              textAlign: 'center'
            }}>
              <SavingsIcon sx={{ 
                color: appMode === 'dark' ? 'rgba(255,255,255,0.7)' : 'rgba(0,0,0,0.6)', 
                mb: 0.5,
                fontSize: '1.2rem'
              }} />
              <Typography variant="body2" sx={{ 
                fontWeight: 600, 
                color: appMode === 'dark' ? '#fff' : '#1a1a1a',
                mb: 0.2
              }}>
                {formatPrice(mainBal || 0)}
              </Typography>
              <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.7rem' }}>
                Accumulated Profit
              </Typography>
            </Box>
          </Grid>

          <Grid item xs={6} sm={3}>
            <Box sx={{ 
              p: 1.5, 
              borderRadius: 2, 
              background: appMode === 'dark' 
                ? 'rgba(255,255,255,0.02)' 
                : 'rgba(0,0,0,0.01)',
              border: appMode === 'dark'
                ? '1px solid rgba(255,255,255,0.08)'
                : '1px solid rgba(0,0,0,0.06)',
              textAlign: 'center'
            }}>
              <PaidIcon sx={{ 
                color: appMode === 'dark' ? 'rgba(255,255,255,0.7)' : 'rgba(0,0,0,0.6)', 
                mb: 0.5,
                fontSize: '1.2rem'
              }} />
              <Typography variant="body2" sx={{ 
                fontWeight: 600, 
                color: appMode === 'dark' ? '#fff' : '#1a1a1a',
                mb: 0.2
              }}>
                {formatPrice(refBal || 0)}
              </Typography>
              <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.7rem' }}>
                Referral Wallet
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </CardContent>
    </Card>

    {/* Investment Vehicle Horizontal Slider */}
    <Card sx={{ mb: 3, mx: 1 }}>
      <CardContent sx={{ py: 2 }}>
        <Typography variant="subtitle1" sx={{ 
          fontWeight: 'bold', 
          fontSize: { xs: '0.95rem', sm: '1.1rem' },
          textTransform: 'uppercase',
          letterSpacing: '0.5px',
          textAlign: 'left',
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          mb: 2
        }}>
          <BusinessCenterIcon color="primary" />
          Investment Vehicle
        </Typography>
        
        <Box sx={{ 
          width: '100%', 
          overflow: 'hidden',
          position: 'relative',
          '&::before, &::after': {
            content: '""',
            position: 'absolute',
            top: 0,
            bottom: 0,
            width: '20px',
            zIndex: 2,
            pointerEvents: 'none'
          },
          '&::before': {
            left: 0,
            background: appMode === 'dark' 
              ? 'linear-gradient(to right, rgba(18,18,18,1), rgba(18,18,18,0))'
              : 'linear-gradient(to right, rgba(255,255,255,1), rgba(255,255,255,0))'
          },
          '&::after': {
            right: 0,
            background: appMode === 'dark' 
              ? 'linear-gradient(to left, rgba(18,18,18,1), rgba(18,18,18,0))'
              : 'linear-gradient(to left, rgba(255,255,255,1), rgba(255,255,255,0))'
          }
        }}>
          <Box sx={{
            display: 'flex',
            animation: 'slideLeft 30s linear infinite',
            '&:hover': {
              animationPlayState: 'paused'
            },
            '@keyframes slideLeft': {
              '0%': { transform: 'translateX(100%)' },
              '100%': { transform: 'translateX(-100%)' }
            }
          }}>
            {/* Dynamic Investment Vehicle from Redux */}
            {plans.length > 0 ? plans.slice(0, 5).map((plan, index) => (
              <Card key={plan.id || index} sx={{ 
                minWidth: 280,
                mx: 1,
                p: 2,
                borderRadius: 3,
                background: appMode === 'dark' 
                  ? 'rgba(255,255,255,0.02)' 
                  : 'rgba(0,0,0,0.02)',
                border: appMode === 'dark'
                  ? '1px solid rgba(255,255,255,0.08)'
                  : '1px solid rgba(0,0,0,0.06)',
                transition: 'all 0.3s ease',
                '&:hover': {
                  transform: 'translateY(-2px)',
                  boxShadow: 3
                }
              }}>
                <Box sx={{ textAlign: 'center', mb: 2 }}>
                  <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 1 }}>
                    {plan.name || `Plan ${index + 1}`}
                  </Typography>
                  
                  {plan.investment_type && (
                    <Typography variant="caption" sx={{ 
                      display: 'block', 
                      mb: 1, 
                      color: '#666',
                      fontSize: '0.7rem'
                    }}>
                      {plan.investment_type}
                    </Typography>
                  )}
                  
                  <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                    {formatPrice(plan.min_amount || 100)} - {parseInt(plan.amount_invested) >= 1000000 ? 'UNLIMITED' : formatPrice(plan.amount_invested || 999)}
                  </Typography>
                  
                  <Typography variant="h5" sx={{ 
                    fontWeight: 'bold', 
                    color: '#4caf50',
                    mb: 1
                  }}>
                    {plan.min_return_percentage && plan.max_return_percentage 
                      ? `${plan.min_return_percentage}% - ${plan.max_return_percentage}%` 
                      : `${parseFloat(plan.total_earning || 8.5).toFixed(2)}%`}
                  </Typography>
                  
                  <Typography variant="caption" color="text.secondary">
                    Duration: {plan.investment_duration_range || plan.duration || '30 days'}
                  </Typography>
                </Box>
                
                <Button 
                  variant="contained" 
                  fullWidth 
                  sx={{ 
                    mt: 1,
                    textTransform: 'none',
                    borderRadius: 2
                  }}
                  component={RouterLink}
                  to="/package/Invest Funds"
                >
                  Invest Now
                </Button>
              </Card>
            )) : (
              // Fallback plans if no data from Redux
              [
                { name: 'Starter Plan', min_amount: 100, amount_invested: 999, min_return_percentage: 8, max_return_percentage: 12, investment_duration_range: '1-2 years' },
                { name: 'Premium Plan', min_amount: 1000, amount_invested: 4999, min_return_percentage: 12, max_return_percentage: 18, investment_duration_range: '2-3 years' },
                { name: 'Professional Plan', min_amount: 5000, amount_invested: 19999, min_return_percentage: 18, max_return_percentage: 25, investment_duration_range: '3-5 years' },
                { name: 'Elite Plan', min_amount: 20000, amount_invested: 49999, min_return_percentage: 25, max_return_percentage: 35, investment_duration_range: '5-7 years' },
                { name: 'Ultimate Plan', min_amount: 50000, amount_invested: 1000000, min_return_percentage: 35, max_return_percentage: 50, investment_duration_range: '7-10 years' }
              ].map((plan, index) => (
                <Card key={index} sx={{ 
                  minWidth: 280,
                  mx: 1,
                  p: 2,
                  borderRadius: 3,
                  background: appMode === 'dark' 
                    ? 'rgba(255,255,255,0.02)' 
                    : 'rgba(0,0,0,0.02)',
                  border: appMode === 'dark'
                    ? '1px solid rgba(255,255,255,0.08)'
                    : '1px solid rgba(0,0,0,0.06)',
                  transition: 'all 0.3s ease',
                  '&:hover': {
                    transform: 'translateY(-2px)',
                    boxShadow: 3
                  }
                }}>
                  <Box sx={{ textAlign: 'center', mb: 2 }}>
                    <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 1 }}>
                      {plan.name}
                    </Typography>
                    <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                      {formatPrice(plan.min_amount)} - {parseInt(plan.amount_invested) >= 1000000 ? 'UNLIMITED' : formatPrice(plan.amount_invested)}
                    </Typography>
                    <Typography variant="h5" sx={{ 
                      fontWeight: 'bold', 
                      color: '#4caf50',
                      mb: 1
                    }}>
                      {plan.min_return_percentage}% - {plan.max_return_percentage}%
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                      Duration: {plan.investment_duration_range}
                    </Typography>
                  </Box>
                  
                  <Button 
                    variant="contained" 
                    fullWidth 
                    sx={{ 
                      mt: 1,
                      textTransform: 'none',
                      borderRadius: 2
                    }}
                    component={RouterLink}
                    to="/package/Invest Funds"
                  >
                    Invest Now
                  </Button>
                </Card>
              ))
            )}
          </Box>
        </Box>
      </CardContent>
    </Card>

    {/* Investment Opportunities Section */}
    <Card sx={{ mb: 3 }}>
      <CardContent>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
          <Typography variant="subtitle1" sx={{ 
            fontWeight: 'bold', 
            fontSize: { xs: '0.95rem', sm: '1.1rem' },
            textTransform: 'uppercase',
            letterSpacing: '0.5px',
            textAlign: 'left',
            display: 'flex',
            alignItems: 'center',
            gap: 1
          }}>
            <GroupIcon color="primary" />
            Crowd Funding
          </Typography>
          <Button 
            size="small" 
            sx={{ textTransform: 'none' }}
            component={RouterLink}
            to="/copy-plans"
          >
            View All
          </Button>
        </Box>
        
        <Grid container spacing={2}>
          {investmentOpportunities.length > 0 ? investmentOpportunities.map((opportunity) => (
            <Grid item xs={12} md={4} key={opportunity.id}>
              <Card sx={{ 
                height: '100%',
                border: '1px solid #e0e0e0',
                '&:hover': {
                  boxShadow: 3,
                  transform: 'translateY(-1px)',
                  transition: 'all 0.3s ease'
                }
              }}>
                <CardContent>
                  <Box sx={{ mb: 2 }}>
                    <Chip 
                      label={opportunity.category} 
                      size="small" 
                      sx={{ mb: 1 }}
                      color="primary"
                      variant="outlined"
                    />
                    <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 1 }}>
                      {opportunity.title}
                    </Typography>
                    <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                      {opportunity.description}
                    </Typography>
                  </Box>

                  <Box sx={{ mb: 2 }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                      <Typography variant="caption">
                        Progress: {formatPrice(opportunity.raisedAmount)} / {formatPrice(opportunity.targetAmount)}
                      </Typography>
                      <Typography variant="caption">
                        {Math.round((opportunity.raisedAmount / opportunity.targetAmount) * 100)}%
                      </Typography>
                    </Box>
                    <LinearProgress 
                      variant="determinate" 
                      value={(opportunity.raisedAmount / opportunity.targetAmount) * 100}
                      sx={{ height: 8, borderRadius: 4 }}
                    />
                  </Box>

                  <Grid container spacing={1} sx={{ mb: 2 }}>
                    <Grid item xs={6}>
                      <Typography variant="caption" color="text.secondary">Expected Return</Typography>
                      <Typography variant="body2" sx={{ fontWeight: 'bold', color: '#2e7d32' }}>
                        {opportunity.expectedReturn}
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography variant="caption" color="text.secondary">Duration</Typography>
                      <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
                        {opportunity.duration}
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography variant="caption" color="text.secondary">Risk Level</Typography>
                      <Chip 
                        label={opportunity.riskLevel} 
                        size="small"
                        sx={{ 
                          bgcolor: getRiskColor(opportunity.riskLevel),
                          color: '#fff',
                          fontWeight: 'bold',
                          fontSize: '0.7rem'
                        }}
                      />
                    </Grid>
                  </Grid>

                  <Button 
                    variant="contained" 
                    fullWidth 
                    sx={{ mt: 1, textTransform: 'none' }}
                    component={RouterLink}
                    to={`/view-trades/${opportunity.id}`}
                  >
                    Invest Now
                  </Button>
                </CardContent>
              </Card>
            </Grid>
          )) : (
            // Fallback opportunities if no data
            [
              {
                id: 1,
                title: "Green Energy Infrastructure Fund",
                description: "Invest in renewable energy projects across emerging markets",
                targetAmount: 500000,
                raisedAmount: 325000,
                expectedReturn: "12-15%",
                duration: "24 months",
                riskLevel: "Medium",
                category: "Sustainable Energy"
              },
              {
                id: 2,
                title: "Tech Startup Growth Fund",
                description: "Early-stage technology companies with high growth potential",
                targetAmount: 750000,
                raisedAmount: 445000,
                expectedReturn: "18-25%",
                duration: "36 months",
                riskLevel: "High",
                category: "Technology"
              },
              {
                id: 3,
                title: "Real Estate Development Project",
                description: "Commercial real estate development in prime urban locations",
                targetAmount: 1200000,
                raisedAmount: 890000,
                expectedReturn: "10-12%",
                duration: "18 months",
                riskLevel: "Low",
                category: "Real Estate"
              }
            ].map((opportunity) => (
              <Grid item xs={12} md={4} key={opportunity.id}>
                <Card sx={{ 
                  height: '100%',
                  border: '1px solid #e0e0e0',
                  '&:hover': {
                    boxShadow: 3,
                    transform: 'translateY(-1px)',
                    transition: 'all 0.3s ease'
                  }
                }}>
                  <CardContent>
                    <Box sx={{ mb: 2 }}>
                      <Chip 
                        label={opportunity.category} 
                        size="small" 
                        sx={{ mb: 1 }}
                        color="primary"
                        variant="outlined"
                      />
                      <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 1 }}>
                        {opportunity.title}
                      </Typography>
                      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                        {opportunity.description}
                      </Typography>
                    </Box>

                    <Box sx={{ mb: 2 }}>
                      <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                        <Typography variant="caption">
                          Progress: {formatPrice(opportunity.raisedAmount)} / {formatPrice(opportunity.targetAmount)}
                        </Typography>
                        <Typography variant="caption">
                          {Math.round((opportunity.raisedAmount / opportunity.targetAmount) * 100)}%
                        </Typography>
                      </Box>
                      <LinearProgress 
                        variant="determinate" 
                        value={(opportunity.raisedAmount / opportunity.targetAmount) * 100}
                        sx={{ height: 8, borderRadius: 4 }}
                      />
                    </Box>

                    <Grid container spacing={1} sx={{ mb: 2 }}>
                      <Grid item xs={6}>
                        <Typography variant="caption" color="text.secondary">Expected Return</Typography>
                        <Typography variant="body2" sx={{ fontWeight: 'bold', color: '#2e7d32' }}>
                          {opportunity.expectedReturn}
                        </Typography>
                      </Grid>
                      <Grid item xs={6}>
                        <Typography variant="caption" color="text.secondary">Duration</Typography>
                        <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
                          {opportunity.duration}
                        </Typography>
                      </Grid>
                      <Grid item xs={6}>
                        <Typography variant="caption" color="text.secondary">Risk Level</Typography>
                        <Chip 
                          label={opportunity.riskLevel} 
                          size="small"
                          sx={{ 
                            bgcolor: getRiskColor(opportunity.riskLevel),
                            color: '#fff',
                            fontWeight: 'bold',
                            fontSize: '0.7rem'
                          }}
                        />
                      </Grid>
                    </Grid>

                    <Button 
                      variant="contained" 
                      fullWidth 
                      sx={{ mt: 1, textTransform: 'none' }}
                    >
                      Invest Now
                    </Button>
                  </CardContent>
                </Card>
              </Grid>
            ))
          )}
        </Grid>
      </CardContent>
    </Card>

    

    <Divider sx={{ my: 2 }} />
    </>
  )
}

export default Index
